import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

type Address = {
  street_name: string,
  street_number: string,
  neighborhood: string,
  city: string,
  state: string,
  complement?: string,
  cep: string
}

export type ChangeUserData = {
  name: string,
  birth_date: string,
  phone: string,
  address: Address
}

type ChangeUserDataResponse = {
  id: string,
  name: string,
  email: string,
  address: Address
  detail?: string;
}

export const changeUserData = async (data: ChangeUserData, user_id: string) => {
  const authToken = getCookie("auth_token");
  const response = await fetch(`${BASE_URL_API}/users/${user_id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  });
  
  const response_address = await fetch(`${BASE_URL_API}/users/address`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data.address),
  });
  
  if (!response.ok || response_address.status !== 204) {
    return { detail: "Erro ao atualizar dados" } as ChangeUserDataResponse;
  }

  return await response.json() as ChangeUserDataResponse;
};